<div
  class="firmware-update"
  *ngIf="gatewayFirmwareUpdateStore.updateStatus$ | async as updateStatus"
>
  <ng-container
    *ngIf="
      updateStatus === updateStatusEnum.IDLE || updateStatus === updateStatusEnum.ERROR;
      else loader
    "
  >
    <button
      mat-raised-button
      color="primary"
      class="firmware-update__button"
      gtm="onStart"
      gtmAction="Start firmware update"
      gtmCategory="gatewayFirmwareUpdate"
      [disabled]="isRsaUser"
      (click)="startFirmwareUpdateProcess()"
    >
      {{
        (updateStatus === updateStatusEnum.ERROR
          ? 'GENERAL.BUTTON.TRY_AGAIN'
          : '+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.UPDATE'
        ) | translate
      }}
    </button>
  </ng-container>
  <ng-template #loader>
    <button
      mat-raised-button
      color="primary"
      class="firmware-update--loading firmware-update__button"
      disabled
    >
      <ng-container *ngIf="updateStatus === updateStatusEnum.DOWNLOADING">
        {{ 'GENERAL.LOADING' | translate }}
        <mat-spinner></mat-spinner>
      </ng-container>
      <ng-container *ngIf="updateStatus === updateStatusEnum.REBOOTING">
        {{ '+GENERAL.REBOOTING' | translate }}
        <mat-spinner></mat-spinner>
      </ng-container>
    </button>
  </ng-template>
  <!-- Domain change - can be ingored because functionallity will be removed -->
  <a
    mat-button
    class="firmware-update__link"
    href="https://www.viessmann-climatesolutions.com/vicare/connectivity-quality.html"
    target="_blank"
    gtm="onGoToPage"
    gtmAction="More info about firmware update"
    gtmCategory="gatewayFirmwareUpdate"
  >
    <u>{{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.RELEASE_NOTE' | translate }}</u>
    <img src="assets/icons/shortcut-default.svg" />
  </a>
</div>
